const cloudinaryBase = 'https://res.cloudinary.com/cancerfonden/image/upload';

export const hero = `${cloudinaryBase}/v1457618284/curatedimages/default-hero.jpg`;

export const collection = [
  {
    image: `${cloudinaryBase}/v1758619266/Blommor2_jealgg.jpg`,
    name: 'blommor'
  },
  {
    image: `${cloudinaryBase}/v1604664514/defaultheroimages/collection/motivbild-minnes-2.jpg`,
    name: 'sten'
  }
  // {
  //   image: `${cloudinaryBase}/v1610465704/defaultheroimages/collection/motivbild-ballong.jpg`,
  //   name: "ballong"
  // }
];

export const genericCertificate = [
  // {
  //   image: `${cloudinaryBase}/v1759326816/rb-illustration_1_f65jjr.svg`,
  //   name: 'rosa band'
  // },
  {
    image: `${cloudinaryBase}/v1614761790/gift-certificate-images/hj-rtmotiv.svg`,
    name: 'hjärta'
  },
  {
    image: `${cloudinaryBase}/v1589794138/gift-certificate-images/gift_flowers.svg`,
    name: 'blomma'
  },
  {
    image: `${cloudinaryBase}/v1614761790/gift-certificate-images/paketmotiv.svg`,
    name: 'present'
  }
];

export const memory = [
  `${cloudinaryBase}/v1604664514/defaultheroimages/collection/motivbild-minnes.jpg`
];

export const memorial = [
  {
    image: `${cloudinaryBase}/v1645691004/assets/memorial-gift/cf-minnessidan-org5315_3.jpg`,
    name: 'sten'
  }
];
